/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import EncountersEncounter from './EncountersEncounter';

/**
 * The EncountersBody model module.
 * @module model/EncountersBody
 * @version v0.3
 */
export default class EncountersBody {
  /**
   * Constructs a new <code>EncountersBody</code>.
   * @alias module:model/EncountersBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EncountersBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EncountersBody} obj Optional instance to populate.
   * @return {module:model/EncountersBody} The populated <code>EncountersBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EncountersBody();
      if (data.hasOwnProperty('encounter'))
        obj.encounter = EncountersEncounter.constructFromObject(data['encounter']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EncountersEncounter} encounter
 */
EncountersBody.prototype.encounter = undefined;

